import { useSocketEvent } from "socket.io-react-hook";
import {
  WSNotificationsResponse,
  WSProfitsResponse,
} from "src/Modules/Arbitrage/types";

export const useWebSocketHandlers = (socket: any, token: string) => {
  const { lastMessage } = useSocketEvent<WSProfitsResponse>(
    socket,
    "profits_updates"
  );
  const { lastMessage: notificationsLastMessage } =
    useSocketEvent<WSNotificationsResponse>(socket, "notifications");
  console.log(
    "λ  - useWebSocketHandlers - notificationsLastMessage:",
    notificationsLastMessage
  );

  const { lastMessage: authenticateLastMessage, sendMessage: authenticate } =
    useSocketEvent(socket, "authenticate");
  const { lastMessage: authenticateAckLastMessage } = useSocketEvent(
    socket,
    "authenticate_ack"
  );

  const { sendMessage: sendSubscribeProfitsMessage } = useSocketEvent(
    socket,
    "subscribe_profits"
  );

  console.log(
    "λ  - useWebSocketHandlers - authenticateAckLastMessage:",
    authenticateAckLastMessage
  );

  console.log(
    "λ  - useWebSocketHandlers - authenticateLastMessage:",
    authenticateLastMessage
  );

  const sendAuthenticate = () => {
    if (!token) throw new Error("Token is required for authentication");
    console.log("λ  - useWebSocketHandlers - sendAuthenticate - token:", token);
    authenticate({ token });
  };

  return {
    lastMessage,
    notificationsLastMessage,
    authenticate: sendAuthenticate,
    sendSubscribeProfitsMessage,
  };
};
